import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { RedactedPlaceholderComponentShadow } from './RedactedPlaceholderComponentShadow.tsx';
import type {
	ReferenceEntity,
	MultiBodiedExtensionActions,
} from '@atlaskit/editor-common/extensions/extension-handler';
import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent.ts';
import type { Mode, Extension } from '@confluence/macro-tracker/entry-points/types.ts';

export const RedactedPlaceholderExtensionHandler: LoadableType<
	{
		mode: Mode;
		extensionKey?: string;
		attributes?: ExperienceAttributes;
		contentId: string;
	} & {
		node: Extension;
	} & {
		showTemplateVariablesInPreview?: boolean;
		showTemplateInputInPreview?: boolean;
		spaceKey: string;
		spaceId?: string;
		references?: ReferenceEntity[];
		multiBodiedExtensionActions?: MultiBodiedExtensionActions;
		noOverlay?: boolean;
	} & {
		redactedAttributes?: {
			extensionKey?: string;
		};
	}
> = LoadableAfterPaint({
	loader: async () => {
		const { RedactedPlaceholder } = await import(
			/* webpackChunkName: "loadable-RedactedPlaceholder" */ './RedactedPlaceholder.tsx'
		);
		return RedactedPlaceholder;
	},
	loading: () => <RedactedPlaceholderComponentShadow />,
});
